(() => {
  function getEmbed(raw) {
    let url;
    try { url = new URL(raw); } catch { return null; }
    if (url.protocol !== 'https:') return null;
    const host = url.hostname.toLowerCase();
    let id = '';
    if (host === 'youtu.be') id = url.pathname.split('/')[1] || '';
    if (host === 'youtube.com' || host === 'www.youtube.com' || host === 'm.youtube.com') {
      id = url.searchParams.get('v') || url.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1] || '';
    }
    if (id && /^[A-Za-z0-9_-]{11}$/.test(id)) return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1';
    if (host === 'instagram.com' || host === 'www.instagram.com') {
      const match = url.pathname.match(/^\/(reel|p|tv)\/([A-Za-z0-9_-]+)\/?/);
      if (match) return 'https://www.instagram.com/' + match[1] + '/' + match[2] + '/embed/';
    }
    return null;
  }

  function init(section) {
    if (section.dataset.videoReady) return;
    section.dataset.videoReady = 'true';
    const rail = section.querySelector('[data-video-rail]');
    if (!rail) return;
    const prev = section.querySelector('[data-video-prev]');
    const next = section.querySelector('[data-video-next]');
    const update = () => {
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    prev.addEventListener('click', () => rail.scrollBy({left: -rail.querySelector('.paw-video__card').getBoundingClientRect().width - 14, behavior: 'smooth'}));
    next.addEventListener('click', () => rail.scrollBy({left: rail.querySelector('.paw-video__card').getBoundingClientRect().width + 14, behavior: 'smooth'}));
    rail.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update);
    update();
    section.querySelectorAll('.paw-video__frame').forEach(frame => {
      if (frame.dataset.customPoster === 'true') return;
      const embed = getEmbed(frame.dataset.videoUrl || '');
      if (!embed?.startsWith('https://www.youtube-nocookie.com/embed/')) return;
      const id = new URL(embed).pathname.split('/').pop();
      let poster = frame.querySelector('.paw-video__poster');
      if (!poster) {
        poster = document.createElement('img');
        poster.className = 'paw-video__poster';
        poster.loading = 'lazy';
        poster.alt = frame.querySelector('.paw-video__play')?.getAttribute('aria-label') || 'Product video';
        frame.prepend(poster);
      }
      const preview = new Image();
      preview.onload = () => {
        if (!preview.naturalWidth) return;
        poster.removeAttribute('srcset');
        poster.removeAttribute('sizes');
        poster.src = preview.src;
      };
      preview.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    });
    rail.addEventListener('click', event => {
      const play = event.target.closest('.paw-video__play');
      if (!play) return;
      const frame = play.closest('.paw-video__frame');
      const src = getEmbed(frame.dataset.videoUrl || '');
      if (!src) return;
      document.querySelectorAll('.paw-video__frame iframe').forEach(iframe => {
        const other = iframe.closest('.paw-video__frame');
        iframe.remove();
        other.querySelector('.paw-video__poster')?.removeAttribute('hidden');
        other.querySelector('.paw-video__play')?.removeAttribute('hidden');
      });
      const iframe = document.createElement('iframe');
      iframe.dataset.userInitiated = 'true';
      iframe.src = src;
      iframe.title = play.getAttribute('aria-label') || 'Product video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      frame.appendChild(iframe);
      frame.querySelector('.paw-video__poster')?.setAttribute('hidden', '');
      play.hidden = true;
    });
  }
  const initAll = root => root.querySelectorAll('.paw-video').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
